'use client';
import useControlled from '@mui/utils/useControlled';

export default useControlled;
